import { fallbackConnectedQuestions } from '../fallbacks.js';
import { formatAnswers, formatLocation, formatPeriod } from '../format.js';
import { buildInfluenceBlock, OPERATION_GUARDRAILS } from '../influence.js';
import type { PromptRequest, PromptSourceBundle } from '../types.js';
import { baseRequest, type CompilerSpec } from './base.js';
import { buildWorldContext } from '../filters.js';

const SPEC: CompilerSpec = {
  purpose: 'connected_questions',
  maxTier: 0,
  allowedTiers: [0],
  budget: { inputTokens: 1200, outputTokens: 800 },
  provider: 'deepseek',
};

export function compileConnectedQuestions(
  source: PromptSourceBundle,
  unansweredDependencyIds: string[],
): PromptRequest {
  const world = buildWorldContext(source);
  const influence = buildInfluenceBlock('connected_questions', world);
  const header = [
    'PURPOSE: connected_questions',
    OPERATION_GUARDRAILS.connected_questions,
    'FORBIDDEN OUTPUT: React, SQL, arbitrary UI components, executable code, or new control types.',
    influence.text,
  ].join('\n');

  const tier0 = [
    `LOCATION: ${formatLocation(world)}`,
    `PERIOD: ${formatPeriod(world.timePeriod)}`,
    `ACCEPTED_ANSWERS:\n${formatAnswers(world.answers)}`,
    `UNANSWERED_DEPENDENCIES: ${unansweredDependencyIds.join(', ') || '(none)'}`,
    `LOCATION_TYPE: ${world.locationType}`,
    `APPROVED_CONTROL_TYPES: single_select, multi_select, short_text, long_text, time_range, day_selection, slider, swatch, review_card`,
  ].join('\n');

  return baseRequest(
    source,
    SPEC,
    { tier0 },
    [],
    [],
    [],
    header,
    {
      local: fallbackConnectedQuestions,
      retryOnValidationError: true,
      noKeyUsesLocal: true,
    },
  );
}

export const connectedQuestionsMaxTier = SPEC.maxTier;
